export const SET_QUESTIONS_DATA = 'SET_QUESTIONS_DATA';
export const SET_MATCH_RULES_RESULT = 'SET_MATCH_RULES_RESULT';
export const SET_PRINT_HTML_PART = 'SET_PRINT_HTML_PART';
export const SET_PRINT_HTML_HEAD = 'SET_PRINT_HTML_HEAD';
export const CLEAR_PRINT_HTML = 'CLEAR_PRINT_HTML';
export const SEND_BUSINESS_CASE_RESULT = 'SEND_BUSINESS_CASE_RESULT';

export const setQuestionsData = questions => ({
  type: SET_QUESTIONS_DATA,
  payload: questions
});
export const setMatchRulesResult = result => ({
  type: SET_MATCH_RULES_RESULT,
  payload: result
});

export const setPrintHtmlPart = (page, html) => ({
  type: SET_PRINT_HTML_PART,
  payload: { page, html }
});

export const setPrintHtmlHead = headHtml => ({
  type: SET_PRINT_HTML_HEAD,
  payload: headHtml
});

export const clearPrintHtml = () => ({ type: CLEAR_PRINT_HTML });
export const sendBusinessCaseResult = resp => ({
  type: 'SEND_BUSINESS_CASE_RESULT',
  payload: resp
});
